import { all, call, put, SagaReturnType, takeLatest } from 'redux-saga/effects';

import * as episodesActions from '@/admin/pages/studyGoBridgeEpisodes/Actions';
import { episodesActionTypes } from '@/admin/pages/studyGoBridgeEpisodes/Constants';
import { processRequest } from '@/services/Api';

import type { Episode } from '@/admin/pages/studyGoBridgeEpisodes/types';

interface EpisodesApiResponse {
	data: {
		study_go_bridge_episodes: Episode[];
	};
}

export function* handleGetEpisodesRequest() {
	try {
		const response: SagaReturnType<typeof processRequest> = yield call(
			processRequest,
			'admin/study_go_bridge/episodes',
			'GET',
		);

		const { study_go_bridge_episodes } = response.data as EpisodesApiResponse['data'];

		yield put(episodesActions.getEpisodesSuccess({ episodes: study_go_bridge_episodes }));
	} catch (error) {
		const errorMessage = error instanceof Error ? error.message : 'Failed to load episodes';
		yield put(episodesActions.getEpisodesError(errorMessage));
	}
}

export default function* episodeSagas(): Generator {
	yield all([
		yield takeLatest(episodesActionTypes.GET_EPISODES_REQUEST, handleGetEpisodesRequest),
	]);
}
